
import Login from "./pages/Login";
import Admin from './pages/Admin';
import { useAuthContext } from './contexts/AuthContext';
import { useMemo } from "react";


const App = () => {
  const { user } = useAuthContext();

  return useMemo(() => {
    if (user) {
      return <Admin />;
    }
  
    return <Login />;
  }, [user]);
}

export default App;
